<template>
  <div class="row" v-if="userData && courses">
    <div class="col-md-6">
      <div class="row">
        <div class="col">
          <a class="justify-center align-center row">
            <unicon
              name="user-circle"
              width="300"
              height="300"
              :fill="grayCol"
              v-if="userData && !userData.avatar"
            />
            <img
              :src="
                require(`@/assets/avatar/Avatar ${userData.avatar}/Avatar-${userData.avatar}.gif`)
              "
              class="avatar-img transition-all"
              width="300"
              height="300"
              v-if="userData && userData.avatar"
            />
          </a>
        </div>
      </div>
      <div class="row my-3">
        <div class="col text-center h3">
          {{ userData.firstname }}
          {{ userData.lastname }}
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button class="button default" @click="$emit('changeView', 'avatar')">
            Cambiar Avatar
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="row mt-5">
        <div class="col-2">
          <unicon name="envelope-alt" :fill="secCol" />
        </div>
        <div class="col-10">
          <div class="row">
            <div class="col">
              Correo de contacto
            </div>
          </div>
          <div class="row">
            <div class="col">
              {{ userData.email }}
            </div>
          </div>
          <div class="row">
            <div
              class="col text-logo pointer"
              @click="showModal.changeEmail = true"
            >
              Cambiar Correo
            </div>
          </div>
        </div>
      </div>
      <div class="row my-4">
        <div class="col-2">
          <unicon name="university" :fill="secCol" />
        </div>
        <div class="col-10">
          <div class="row">
            <div class="col">
              Colegio y Cursos Asignados
            </div>
          </div>
          <div class="row">
            <div class="col">
              {{ userData.school.name }}
            </div>
          </div>
          <div class="row" v-for="(course, i) in courses" :key="i">
            <div class="col">
              {{ course.name }}
            </div>
          </div>
          <!-- <div class="row">
            <div class="col text-logo">
              Editar
            </div>
          </div> -->
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-2">
          <unicon name="padlock" :fill="secCol" />
        </div>
        <div class="col-10">
          <div class="row">
            <div class="col">
              Seguridad
            </div>
          </div>
          <div class="row">
            <div
              class="col text-logo pointer"
              @click="showModal.changePassword = true"
            >
              Cambiar Contraseña
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <ChangeEmailModal v-if="showModal.changeEmail" @close="changedMail" />
    <ChangedPasswordModal
      v-if="showModal.changePassword"
      @close="showModal.changePassword = false"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import ChangeEmailModal from "@/components/userProfile/ChangeEmailModal";
import ChangedPasswordModal from "@/components/userProfile/ChangedPasswordModal";

export default {
  name: "ProfileView",
  components: {
    ChangeEmailModal,
    ChangedPasswordModal,
  },
  computed: {
    ...mapState(["teacherData", "userData", "dataUrl", "courseList"]),
  },
  data() {
    let { secCol, grayCol } = this.$store.getters;

    return {
      secCol,
      grayCol,
      courses: null,
      showModal: {
        changeEmail: false,
        changePassword: false,
      },
    };
  },
  methods: {
    ...mapMutations(["setUserData"]),
    getCourses() {
      this.courses = this.courseList;
    },
    changedMail(newMail) {
      if (newMail) {
        let userData = this.userData;
        userData.email = newMail;
        this.setUserData(userData);
      }
      this.showModal.changeEmail = false;
    },
  },
  mounted() {
    this.getCourses();
  },
};
</script>
